import React, { useEffect } from 'react';
import { Modal } from 'antd';
import { useDispatch, connect } from 'react-redux';
import { hideRegisterSuccessModal } from '../../../Actions/Authentication';
import { ReactComponent as SuccessIcon } from '../../../assets/icons/success.svg';

import './index.scss';

const RegisterSuccessModal = ({ registerSuccessModalShown }) => {
   const dispatch = useDispatch();
   const modalConfig = {
      visible: registerSuccessModalShown,
      width: 400,
      footer: null,
      afterClose: () => window.location.reload(),
      className: 'register-success-modal',
      centered: true
   };

   useEffect(() => {
      if (registerSuccessModalShown) {
         setTimeout(() => {
            dispatch(hideRegisterSuccessModal());
         }, 3000);
      }
   }, [registerSuccessModalShown]);

   return (
      <Modal {...modalConfig}>
         <SuccessIcon />
         <h1>สร้างบัญชีเรียบร้อยแล้ว</h1>
      </Modal>
   );
};

const mapStateToProps = (state) => {
   return {
      registerSuccessModalShown: state.Authentication.registerSuccessModalShown
   };
};
export default connect(mapStateToProps)(RegisterSuccessModal);
